<template>
    <b-container fluid="">
        <b-row>
            <div class="col-sm-12 mt-3">
                <h3>
                    Lista de Anticipos
                </h3>
            </div>
            <div class="col-sm-12 mt-3">
                <div class="contenedor_lista_anticipos">

                    <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">
                        <thead>
                            <tr>
                                <th style="text-align: center;width:10%;">
                                    Fecha
                                </th>
                                <th style="text-align: center;width:15%;">
                                    Código
                                </th>
                                <th style="text-align: center;width:25%;">
                                    Comentarios
                                </th>
                                <th style="text-align: center;width:15%;">
                                    Sucursal
                                </th>
                                <th style="text-align: center;width:15%;">
                                    Monto
                                </th>
                                <th style="text-align: center;width:10%;">
                                    Completo
                                </th>
                                <th style="text-align: center;width:10%;">
                                    ...
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in datos_capital" :key="index">
                                <td style="text-align: center;">
                                    {{ item.fecha }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.correlativo_anticipo }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.comentarios }}
                                </td>
                                <td style="text-align: center;">
                                    {{ obtenerNombreSucursal(item.sucursal) }}
                                </td>
                                <td style="text-align: center;">
                                    Q{{ item.monto.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    }) }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.completo ? 'Sí' : 'No' }}
                                </td>
                                <td style="text-align: center;">
                                    <button type="button" id="ver_detalle_deposito" style="font-size: 9px;"
                                        class="btn btn-sm btn-outline-dark" @click="abrir_modal_detalle(item)"><i
                                            class="fas fa-eye"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-row>

        <ModalDetalleAnticipos v-if="modal_detalle" :capital="item_seleccionado" :registros="registros"
            v-on:salir="cerrar_modal_detalle" />
    </b-container>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import ModalDetalleAnticipos from './ModalDetalleAnticipos.vue';

    export default {
        name: 'Lista',
        components: {
            ModalDetalleAnticipos
        },
        computed: {
            ...mapState(['id_empresa_seleccionada', 'sucursales']),
            obtenerNombreSucursal() {
                return (codigo) => {
                    if (!codigo) return 'N/A';

                    const sucursal = this.sucursales.find(s => s.codigo === codigo);
                    return sucursal ? sucursal.nombre : `Sucursal ${codigo}`;
                };
            }
        },
        data() {
            return {
                datos_capital: [],
                registros: [],
                modal_detalle: false,
                item_seleccionado: {}
            }
        },
        methods: {
            async obtener_registros() {
                let f = {
                    api: `anticipos?filters[empresa][$eq][0]=${this.id_empresa_seleccionada}&filters[capital][$eq][1]=true`
                }

                let r = await this.obtener_data(f)
                this.datos_capital = r

                let x = {
                    api: `anticipos?filters[empresa][$eq][0]=${this.id_empresa_seleccionada}&filters[capital][$eq][1]=false`
                }

                let y = await this.obtener_data(x)
                this.registros = y

            },
            abrir_modal_detalle(item) {
                this.item_seleccionado = item;
                this.modal_detalle = true;
            },
            cerrar_modal_detalle() {
                this.modal_detalle = false;
            },
            ...mapActions(['obtener_data'])
        },
        mounted() {
            this.obtener_registros()
        },
    }
</script>

<style>
    .contenedor_lista_anticipos {
        width: 100%;
        height: calc(100vh - 140px);
        overflow: auto;
    }
</style>